import { render, staticRenderFns } from "./scroll-to-top-button.vue?vue&type=template&id=209a3328&"
import script from "./scroll-to-top-button.vue?vue&type=script&lang=js&"
export * from "./scroll-to-top-button.vue?vue&type=script&lang=js&"
import style0 from "./scroll-to-top-button.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports